import { Tooltip } from '../../Tooltip';
import { Root } from '../styled';
export function Avatar(props) {
    const { children, size = 'lg', appearance = 'primary', shape = 'circle', solid = false, className, tooltip } = props;
    return (<Tooltip disabled={!tooltip} {...tooltip}>
      <Root $size={size} $appearance={appearance} $shape={shape} className={className} $solid={solid}>
        {children}
      </Root>
    </Tooltip>);
}
